import { Layout } from "antd";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

import { Button } from "@components/Button";
import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";

import { BlockItem } from "./BlockItem";
import { WidgetItem } from "./WidgetItem";

const GlobalStyle = createGlobalStyle`
  #root, body {
    overflow: auto;
    background-color: black;
  }
`;

const Container = styled(Layout)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: black;
`;

const AdsLayout = styled.div`
  position: relative;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  box-sizing: border-box;
`;

const ContainerInteract = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-grow: 0;
`;

const LetStartButton = styled(Button)`
  width: 100px;
  height: 100px;
  border-radius: 200px;
  color: ${COLOR_WHITE};
  border: 2px solid ${COLOR_WHITE};
`;

export default () => {
  const params = useParams();
  const importantCampaignId = _.get(params, ["id"]);
  const [isReady, setIsReady] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [widgets, setWidgets] = useState([]);
  const [campaignElapsedTime, setCampaignElapsedTime] = useState(0);
  const [currentCampaignIndex, setCurrentCampaignIndex] = useState(0);
  const intervalRef = useRef(null);
  const [playCampaignCount, setPlayCampaignCount] = useState(1);

  const [isInteract, setIsInteract] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleNextMediaRefs = useRef([]);

  const currentCampaign = _.get(campaign, [currentCampaignIndex]);
  //   const currentCampaignMaxDuration = _.get(currentCampaign, ["max_duration"]);

  const initData = async () => {
    console.log("importantCampaignId :>> ", importantCampaignId);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/important-campaigns-preview",
      isAuth: true,
      data: { id: importantCampaignId },
    });

    console.log("resp :>> ", resp);
    if (_.get(resp, ["status"])) {
      // find max duration
      const widgets = _.get(resp, ["result", "importantCampaignWidgets"]);
      setWidgets(widgets);
      const results = _.chain(resp)
        .get(["result"])
        .thru((item) => {
          return [{ ...item }];
        })
        .map((item) => {
          const filteredAdsBlocks = _.filter(
            _.get(item, "importantCampaignBlocks"),
            (block) => {
              const blockMedias = _.get(block, "importantCampaignBlocks");
              return _.size(blockMedias) > 0;
            }
          );

          return { ...item, adsBlocks: filteredAdsBlocks };
        })
        .filter((item) => {
          const adsBlocks = _.get(item, ["importantCampaignBlocks"]);
          return _.size(adsBlocks) > 0;
        })
        .map((item) => {
          const adsBlocks = _.chain(item)
            .get("importantCampaignBlocks")
            .map((block) => {
              const updatedBlockMedias = _.chain(block)
                .get(["importantCampaignBlockMedias"])
                .map((item, index) => {
                  const rounds = _.get(item, ["repeat"]);
                  return _.times(rounds, () => ({
                    ...item,
                  }));
                })
                .flatMap()
                .value();
              return {
                ...block,
                blockMedias: updatedBlockMedias,
              };
            })
            .value();

          // console.log("adsBlocks :>> ", adsBlocks);
          return { ...item, adsBlocks };
        })
        .map((item) => {
          const maxDuration = _.chain(item)
            .get(["importantCampaignBlocks"])
            .map((item) => {
              const blockMedias = _.get(item, ["importantCampaignBlockMedias"]);
              return _.sumBy(blockMedias, "duration");
            })
            .max()
            .value();
          return { ...item, max_duration: maxDuration };
        })
        .value();
      setIsLoading(false);
      setIsReady(_.isEmpty(results) ? false : true);
      setCampaign(results);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    console.log("campaign :>> ", campaign);
    console.log("currentCampaignIndex :>> ", currentCampaignIndex);
    if (_.size(campaign) > 0 && isInteract) {
      const timer = setTimeout(() => {
        handleNextCampaign();
      }, _.get(campaign, [currentCampaignIndex, "max_duration"]) * 1000);

      intervalRef.current = setInterval(() => {
        setCampaignElapsedTime((prev) => prev + 1);
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(intervalRef.current);
      };
    }
  }, [playCampaignCount, currentCampaignIndex, campaign, isInteract]);

  const handleNextCampaign = () => {
    setCampaignElapsedTime(0);
    setCurrentCampaignIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % _.size(campaign);
      if (nextIndex === 0) {
        setPlayCampaignCount((prev) => prev + 1);
      }
      return nextIndex;
    });
  };

  const handleSkip = () => {
    // เรียกฟังก์ชัน handleNextMedia ของ BlockItem ทุกบล็อก
    handleNextMediaRefs.current.forEach((handleNextMedia) => {
      if (handleNextMedia) handleNextMedia();
    });
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        {isReady ? (
          <AdsLayout
            width={_.get(currentCampaign, ["width"])}
            height={_.get(currentCampaign, ["height"])}
          >
            {!isInteract && (
              <ContainerInteract>
                <LetStartButton onClick={() => setIsInteract(true)}>
                  <Text
                    color={COLOR_WHITE}
                    fontWeight="600"
                  >{`Let's Start`}</Text>
                </LetStartButton>
              </ContainerInteract>
            )}

            {isInteract && (
              <Button
                style={{
                  position: "fixed",
                  bottom: 50,
                  right: 50,
                  background: "white",
                  zIndex: 2000,
                }}
                onClick={handleSkip}
              >
                <Text>Skip {" >>"}</Text>
              </Button>
            )}
            {isInteract &&
              !_.isEmpty(widgets) &&
              _.chain(widgets)
                .map((item, index) => {
                  return <WidgetItem key={index} widget={item} index={index} />;
                })
                .value()}

            {isInteract &&
              !_.chain(currentCampaign)
                .get(["importantCampaignBlocks"])
                .isEmpty()
                .value() &&
              _.chain(currentCampaign)
                .get(["importantCampaignBlocks"], [])
                .map((item, index) => {
                  return (
                    <BlockItem
                      index={index}
                      key={index}
                      block={item}
                      playCampaignCount={playCampaignCount}
                      handleNextMediaRef={(el) =>
                        (handleNextMediaRefs.current[index] = el)
                      }
                    />
                  );
                })
                .value()}
          </AdsLayout>
        ) : null}
      </Container>
    </>
  );
};
